import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import {
  PutWidgetResponseBodyType,
  WidgetDto,
  WidgetTypeType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateWidgetAfterPut } from "../../store/slices/widgets";
import { api } from "../api";
import { widgetKeys } from "../queryKeys";

const putWidget = async (data: Partial<WidgetDto>) => {
  const resp = await api.put<PutWidgetResponseBodyType>(
    `/v2/widgets/${data.id}`,
    { widget: data }
  );
  return resp.data;
};

export const usePutWidget = (widgetType: WidgetTypeType) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation<PutWidgetResponseBodyType, Error, Partial<WidgetDto>, any>(
    {
      mutationKey: [`mutateWidget-${widgetType}`],
      mutationFn: async (data: Partial<WidgetDto>) => putWidget(data),
      onSuccess: async (data) => {
        await queryClient.invalidateQueries({ queryKey: widgetKeys.all });
        dispatch(updateWidgetAfterPut(data.widget));
        toast.success("Successfully saved widget!");
      },
      onError: async () => {
        toast.error("Oops! Unable to save changes.");
      },
    }
  );
};
